/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorBlogSlider from 'base/components/labrador/BlogSlider';

export const DynamicLabradorBlogSlider: typeof LabradorBlogSlider = (props) => {
    return <ErrorBoundary><LabradorBlogSlider {...props} /></ErrorBoundary>;
}
export type DynamicLabradorBlogSliderProps = PropsFromComponent<typeof LabradorBlogSlider>;
